export default {"src":"/_next/static/image/public/images/flags/flag_670.6dc471cd29353c04313b0768bb5e07ab.svg","height":16,"width":25};